import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var h = Object.defineProperty;
var u = function u(n, t, e) {
  return t in n ? h(n, t, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: e
  }) : n[t] = e;
};
var c = function c(n, t, e) {
  return u(n, typeof t != "symbol" ? t + "" : t, e), e;
};
import f, { Component as m, createElement as v, Children as b } from "react";
var p = function p(n, t) {
    return typeof getComputedStyle < "u" ? getComputedStyle(n, null).getPropertyValue(t) : n.style.getPropertyValue(t);
  },
  y = function y(n) {
    return p(n, "overflow") + p(n, "overflow-y") + p(n, "overflow-x");
  },
  w = function w(n) {
    if (!(n instanceof HTMLElement)) return window;
    var t = n;
    for (; t && !(t === document.body || t === document.documentElement || !t.parentNode);) {
      if (/(scroll|auto)/.test(y(t))) return t;
      t = t.parentNode;
    }
    return window;
  };
var g = /*#__PURE__*/function (_m) {
  _inherits(g, _m);
  var _super = _createSuper(g);
  function g(e) {
    var _this;
    _classCallCheck(this, g);
    _this = _super.call(this, e);
    c(_assertThisInitialized(_this), "elementObserver");
    c(_assertThisInitialized(_this), "wrapper");
    c(_assertThisInitialized(_this), "lazyLoadHandler", function (e) {
      var o, i;
      var s = _this.props.onContentVisible,
        _e = _slicedToArray(e, 1),
        r = _e[0],
        l = r.isIntersecting;
      if (l) {
        _this.setState({
          visible: !0
        }, function () {
          s && s();
        });
        var a = (o = _this.wrapper) == null ? void 0 : o.current;
        a && a instanceof HTMLElement && ((i = _this.elementObserver) == null || i.unobserve(a));
      }
    });
    _this.elementObserver = null, _this.wrapper = f.createRef(), _this.state = {
      visible: !1
    };
    return _this;
  }
  _createClass(g, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var o;
      this.getEventNode();
      var _this$props = this.props,
        e = _this$props.offset,
        s = _this$props.threshold,
        r = {
          rootMargin: typeof e == "number" ? "".concat(e, "px") : e || "0px",
          threshold: s || 0
        };
      this.elementObserver = new IntersectionObserver(this.lazyLoadHandler, r);
      var l = (o = this.wrapper) == null ? void 0 : o.current;
      l instanceof HTMLElement && this.elementObserver.observe(l);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(e, s) {
      return s.visible;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var s, r;
      var e = (s = this.wrapper) == null ? void 0 : s.current;
      e && e instanceof HTMLElement && ((r = this.elementObserver) == null || r.unobserve(e));
    }
  }, {
    key: "getEventNode",
    value: function getEventNode() {
      var e;
      return w((e = this.wrapper) == null ? void 0 : e.current);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        e = _this$props2.children,
        s = _this$props2.className,
        r = _this$props2.height,
        l = _this$props2.width,
        o = _this$props2.elementType,
        i = this.state.visible,
        a = {
          height: r,
          width: l
        },
        d = "LazyLoad".concat(i ? " is-visible" : "").concat(s ? " ".concat(s) : "");
      return v(o || "div", {
        className: d,
        style: a,
        ref: this.wrapper
      }, i && b.only(e));
    }
  }]);
  return g;
}(m);
c(g, "defaultProps", {
  elementType: "div",
  className: "",
  offset: 0,
  threshold: 0,
  width: null,
  onContentVisible: null,
  height: null
});
export { g as default };